<template>
  <div
    class="new-zip-preview"
  >
    <div
      class="preview-list"
    >
      <div class="container">
        <div class="list">
          <el-dropdown
            trigger="click"
            placement="bottom-start"
            @command="handleCommand"
            @visible-change="handleVisiable"
          >
            <div
              class="list-item active"
            >
              <div class="logo" :class="getFileType(currentFile.suffixType)"></div>
              <span class="title">{{ currentFile.name | doEslipse}}</span>
              <i v-if="isExpand" class="el-icon-caret-top fontcolor2"></i>
              <i v-else class="el-icon-caret-bottom fontcolor2"></i>
            </div>
            <el-dropdown-menu
              class="new-zip-preview-dropdown"
              slot="dropdown"
            >
              <el-dropdown-item
                v-for="(item, index) in zipFileList"
                :key="index"
                :command="index"
              >
                <div
                  class="list-item"
                >
                  <div class="logo" :class="getFileType(item.suffixType)"></div>
                  <div
                    class="title fontcolor3"
                    :class="[index === curFilePage ? 'active': '']"
                  >{{ item.name }}</div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="num">共{{ totalFilePage }}份</div>
        <div class="btn" v-if="(currentFile.status === 'Finished' && imageList.length > 0)">
          <span
            class="btn-next"
            :class="[curImagePage === 1 ? 'btn-disable' : '']"
            @click="handleNext()"
          >
            <i class="el-icon-arrow-left"></i>
          </span>
          <span class="page">{{ curImagePage }}/{{ picsCount }}</span>
          <span
            class="btn-pre"
            :class="[curImagePage === totalImagePage ? 'btn-disable' : '']"
            @click="handlePre()"
          >
            <i class="el-icon-arrow-right"></i>
          </span>
        </div>
      </div>

    </div>
    <!-- zip内文件转码完则请求图片 -->
    <div
      v-if="(currentFile.status === 'Finished' && picsCount > 0)"
      class="preview-content"
    >
      <template v-if="imageList.length > 0">
        <div
          v-if="imageList.length > 0 && !changeLoading"
          class="scrollWrap"
          @scroll="scrollLoadMore"
        >
          <img
            v-for="(item, index) in imageList"
            class="scrollWrap-item"
            :key="index"
            :value="item | httpToHttps"
            fit="contain"
          />
        </div>
      </template>
      <div class="unble-preview" v-else>
        <div class="unble-preview-wrap">
          <img src="../images/no_data.png" alt>
          <p>无法预览！！！</p>
          <p>当前文档不提供在线查看，请下载使用</p>
        </div>
      </div>
    </div>
    <!-- 未转码完则走以前的预览方式 -->
    <div class="preview-content preview-other" v-else>
      <c-office-preview v-if="isOffice(currentFile.suffixType)" type="zipFile" :file="currentFile"></c-office-preview>
      <div class="unble-preview" v-else>
        <div class="unble-preview-wrap">
          <img src="../images/no_data.png" alt>
          <p>无法预览！！！</p>
          <p>当前文档不提供在线查看，请下载使用</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFileType } from '@/utils/tools';
import COfficePreview from './COfficePreview';

export default {
  props: {
    zipFileList: {
      type: Array,
      default: () => [],
    }
  },
  components: {
    COfficePreview
  },
  name: "c-new-zip-preview",
  data() {
    return {
      totalFilePage: 0, // zip内文件总数
      curFilePage: 0,
      currentFile: { // 当前显示的文件
        type: 'zipFile',
        id: '',
        name: '加载中',
        suffixType: 'loading'
      },
      imageList: [], // 当前显示文件完成转码后的图片列表
      curImagePage: 1, // 当前显示的图片
      totalImagePage: 0, // 转码后图片总数
      picsCount: 0, // 原文档图片总数
      isExpand: false,
      changeLoading: false,
      lazyPage: 0,
      isButtom: false,
      isClick: false,
      isOver: false
    };
  },
  mounted () {
    if (this.zipFileList.length > 0) {
      this.totalFilePage = this.zipFileList.length;
      this.setCurFile(this.zipFileList[0]);
    }
  },
  watch: {
    zipFileList(newValue, oldValue) {
      if (newValue.length > 0) {
        this.totalFilePage = newValue.length;
        this.setCurFile(newValue[0]);
      }
    }
  },
  filters: {
    doEslipse: function(value) {
      return value.length <= 25 ? value : value.substr(0, 25) + '...';
    }
  },
  methods: {
    scrollLoadMore() {
      if (this.imageList.length <= 0) {
        return;
      }
      if (this.isClick) {
        return;
      }
      let scrollTop = document.getElementsByClassName('scrollWrap')[0].scrollTop;
      if (document.getElementsByClassName('scrollWrap-item')[0]) {
        let imgHei = document.getElementsByClassName('scrollWrap-item')[0].height;
        let page = Math.floor((scrollTop + 300) / imgHei);
        this.curImagePage = page + 1;
      }
      this.isToButtom();
    },
    /**
     * @description: 获取文件后缀
     * @param {*} filesuffix
     * @return {*}
     */
    getFileType (filesuffix) {
      return getFileType(filesuffix)
    },
    isOffice (suffixType = '') {
      let lowerType = suffixType.toLowerCase()
      let officeExt = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx',  'pdf']
      if ($.inArray(lowerType, officeExt) !== -1) {
        return true
      }
    },
    /**
     * @description: 往前翻页
     * @return {*}
     */
    handleNext() {
      this.isClick = true;
      if (this.curImagePage <= 1) {
        this.curImagePage = 1;
      }
      else {
        this.curImagePage--;
      }
      let scrollWrap = document.getElementsByClassName('scrollWrap')[0];
      let imgHei = document.getElementsByClassName('scrollWrap-item')[0].height;
      let page = this.curImagePage - 1;
      scrollWrap.scrollTo(0, imgHei * page);
      this.isClick = false;
    },
    /**
     * @description: 往后翻页
     * @return {*}
     */
    handlePre() {
      this.isClick = true;
      if (this.curImagePage >= this.totalImagePage) {
        this.curImagePage = this.totalImagePage;
      }
      else {
        this.curImagePage++;
      }
      let scrollWrap = document.getElementsByClassName('scrollWrap')[0];
      let imgHei = document.getElementsByClassName('scrollWrap-item')[0].height;
      let page = this.curImagePage - 1;
      scrollWrap.scrollTo(0, imgHei * page);

      if (this.curImagePage >= this.lazyPage - 1 && this.lazyPage < this.imageList.length - 1) {
        this.setLazyUrl(this.lazyPage + 1);
      }
      this.isClick = false;
    },
    /**
     * @description: 切换文件
     * @param {*} command
     * @return {*}
     */
    handleCommand(command) {
      this.curFilePage = command;
      this.setCurFile(this.zipFileList[command]);
      this.isOver = false;
    },
    handleVisiable(e) {
      this.isExpand = e;
    },
    /**
     * @description: 设置当前选中文件
     * @param {*} list
     * @return {*}
     */
     setCurFile(list) {
      this.currentFile.suffixType = 'loading';
      if (list.status !== 'Finished') {
        let filename = list.fileAddress.split('/').pop();
        this.currentFile = {
          ...list,
          name: filename.split('.')[0],
          id: list.id,
          type: 'document',
          suffixType: filename.split('.')[1]
        }
      }
      else {
        this.currentFile = {
          ...list
        };
        this.imageList = list.pictureUrls;
        this.totalImagePage = list.pictureUrls.length;
        this.picsCount = list.picsCount;
        this.curImagePage = 1;
        this.lazyPage = 0;
        if (this.imageList.length <= 0) {
          return;
        }
        this.$nextTick(() => {
          let len = this.imageList.length < 3 ? this.imageList.length : 3;
          for (let i = 0; i < len; i++) {
            this.setLazyUrl(i);
          }
          document.getElementsByClassName('scrollWrap')[0].scrollTop = 0;
        })
      }
    },
    // 手动懒加载
    setLazyUrl(i) {
      if (i >= this.imageList.length) {
        this.isOver = true;
        return;
      }
      let url = document.getElementsByClassName('scrollWrap-item')[i].getAttribute('value');
      document.getElementsByClassName('scrollWrap-item')[i].src = url;
      if (i > this.lazyPage) {
        this.lazyPage = i;
      }
    },
    /**
     * @description: 监听是否滚动到底部
     * @return {*}
     */
    isToButtom() {
      this.isOver = false;
      // 防抖
      if (this.isButtom) {
        return;
      }
      this.isButtom = true;
      this.$nextTick(() => {
        // 进入nexTick
        const scrollWrap = document.getElementsByClassName("scrollWrap")[0];   // 获取滚动条的dom
        // 获取距离顶部的距离
        const scrollTop = scrollWrap.scrollTop;
        // 获取可视区的高度
        const windowHeight = scrollWrap.clientHeight;
        // 获取滚动条的总高度
        const scrollHeight = scrollWrap.scrollHeight;
        if (scrollTop + windowHeight >= scrollHeight - 100) {
          // 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部
          if (this.imageList.length > this.lazyPage) {
            this.setLazyUrl(this.lazyPage + 1);
          }
          else {
            this.isOver = true;
          }
        }
        this.isButtom = false;
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.new-zip-preview {
  position: relative;
  width: 100%;
  padding: 0 12px 31px 12px;
  box-sizing: border-box;
  min-height: 500px;
  background: #fff;

  .preview-list {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
    height: 50px;
    padding: 12px 0 0 0;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 4px 4px 0px 0px;
    border-bottom:  1px solid #E7E7E7;
    user-select: none;

    .container {
      width: 1000px;
      margin: 0 auto;
    }

    .num {
      float: left;
      font-size: 16px;
      color: #666;
      margin-left: 24px;
    }

    .btn {
      float: right;
      margin-right: 12px;
      font-size: 16px;
      font-weight: normal;
      color: #606266;
      height: 30px;
      overflow: hidden;

      .btn-next {
        float: left;
        border: 0;
        min-width: 0px;
      }

      .page {
        float: left;
        margin: 0 10px;
      }

      .btn-pre {
        float: left;
      }

      i {
        cursor: pointer;

        &:hover {
          color: #000 !important;
        }
      }

      .btn-disable {
        i {
          cursor: default;
          color: #ccc !important;

          &:hover {
            color: #ccc !important;
          }
        }
      }
    }

    .list {
      cursor: pointer;
      float: left;
      max-width: calc(100% - 220px);
      height: 30px;
      margin-left: 12px;

      .list-item {
        width: 100%;
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        color: #303133;

        .logo {
          width: 24px;
          height: 30px;
          float: left;
          margin-right: 14px;
          background-size: cover;
          background:  url(../images/icon-word.png) no-repeat;
        }
        .logo.doc {
          background:  url(../images/icon-word.png) no-repeat;
        }
        .logo.ppt {
          background:  url(../images/icon-ppt.png) no-repeat;
        }
        .logo.pdf {
          background:  url(../images/icon-pdf.png) no-repeat;
        }
        .logo.image {
          background:  url(../images/icon-image.png) no-repeat;
        }
        .logo.video {
          background:  url(../images/icon-video.png) no-repeat;
        }
        .logo.audio {
          background:  url(../images/icon-music.png) no-repeat;
        }

        .logo.excel {
          background:  url(../images/icon-excel.svg) no-repeat;
        }

        .title {
          max-width: calc(100% - 62px);
          height: 30px;
          float: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        i {
          margin-left: 8px;
        }
      }
    }
  }

  .preview-content {
    background: #fff;
    padding: 70px 38px 0 38px;
    border-bottom:  1px solid #E7E7E7;

    .scrollWrap {
      height: 700px;
      overflow-y: auto;
       /* 隐藏滚动条 */
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */

      img.scrollWrap-item {
        border: 1px solid #ddd;
      }
    }

    .scrollWrap::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }

    img {
      width: 100%;
      display: block;
    }
  }

  .preview-other {
    padding: 70px 0 32px 0;
    border-bottom: 0;
  }

  .unble-preview {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 600px;
    border: 1px solid rgba(204, 204, 204, 1);
    background: rgba(255, 255, 255, 1);
  }

  .img-wrap {
    overflow: hidden
  }

  .img-wrap img {
    width: 100%;
  }
  .unble-preview-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    text-align: center;

    .download {
      margin-top: 16px;
      border-radius: 4px;
      font-size: 16px;
    }

    p {
      line-height: 36px;
    }

    div.over-notice-btn {
      margin: 24px auto 0 auto;
      width: 128px;
      height: 40px;
      border-radius: 4px;
      color: #fff;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>


<style lang="scss">
.new-zip-preview {
  .preview-list {
    .list {
      .el-dropdown {
        width: 100%;
      }
    }
  }
}

.new-zip-preview-dropdown {
  width: 884px;
  max-height: 400px;
  overflow-y: auto;
  margin-left: -20px !important;

  li.el-dropdown-menu__item {
    height: 30px;
    margin-bottom: 16px;

    &:last-of-type {
      margin-bottom: 0 !important;
    }
  }

  li.el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #fff;
  }


  .list-item {
    width: calc(100% - 34px);
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    color: #303133;
    display: inline-block;

    .logo {
      width: 24px;
      height: 30px;
      float: left;
      margin-right: 14px;
      background-size: cover;
      background:  url(../images/icon-word.png) no-repeat;
    }

    .logo.doc {
      background:  url(../images/icon-word.png) no-repeat;
    }
    .logo.ppt {
      background:  url(../images/icon-ppt.png) no-repeat;
    }
    .logo.pdf {
      background:  url(../images/icon-pdf.png) no-repeat;
    }
    .logo.image {
      background:  url(../images/icon-image.png) no-repeat;
    }
    .logo.video {
      background:  url(../images/icon-video.png) no-repeat;
    }
    .logo.audio {
      background:  url(../images/icon-music.png) no-repeat;
    }

    .logo.excel {
      background:  url(../images/icon-excel.svg) no-repeat;
    }

    .title {
      width: calc(100% - 84px);
      height: 30px;
      float: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &:after {
      visibility: hidden;
      display: block;
      font-size: 0;
      content: " ";
      clear: both;
      height: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/previewV2/components/CNewZipPreview.vue